import TomSelect from 'tom-select'
import {Controller} from "@hotwired/stimulus"


export default class extends Controller {
    static targets = ["voucher_type", "row"];
    static values = {
        url: String,
        plugins: {type: Array, default: ['checkbox_options', 'caret_position', 'remove_button']},
        wrapperCss: {type: Array, default: []},
        controlCss: {type: Array, default: []},
        create: false
    }


    updateUrl(event) {
        const url = new URL(window.location.href);
        const date = event.target.parentElement.value;
        url.searchParams.set('date', date);
        if (window.location.href !== url.href) {
            window.location.href = url.href;
        }
    }

    glSelection(event) {
        var value = event.target.value
        var element = event.target.parentElement.parentElement
        var selectTag = element.getElementsByClassName('gl-account-tag')[0]
        selectTag.options.length = 0
        this.emptyOption(selectTag)
        selectTag.tomselect.clearOptions()
        if (value === "Take from Column") {
            selectTag.tomselect.destroy()
            new TomSelect(selectTag, {});
            selectTag.tomselect.addOption({value: "Ledger", text: "Ledger"});
            selectTag.tomselect.addOption({value: "Party", text: "Party"});
        } else {
            if (value === "Static") {
                var url = new URL(document.getElementById('entry_config_lists').dataset['url']).href
                selectTag.tomselect.destroy()
                new TomSelect(selectTag, {
                    valueField: 'id', labelField: 'text', searchField: 'text', create: false, preload: 'focus',

                    shouldLoad: function (query) {
                        return query.length > 1;
                    },

                    load: function (query, callback) {
                        var url2 = url + `?q=` + encodeURIComponent(query);
                        fetch(url2)
                            .then(response => response.json())
                            .then(json => {
                                callback(json.items);

                            }).catch(() => {
                            callback();
                        });
                    },
                });
                selectTag.tomselect.refreshOptions()
                selectTag.tomselect.sync()
            } else {
                selectTag.tomselect.destroy()
                new TomSelect(selectTag, {});
                let option = document.createElement('option');
                selectTag.appendChild(option);
            }
        }
        selectTag.tomselect.refreshOptions()
        selectTag.tomselect.sync()
    }


    cctSelection(event) {
        var value = event.target.value
        var currentElement = event.target.parentElement.parentElement

        var cctTbodyColumn = Array.from(currentElement.getElementsByClassName("cct-tbody-column"))
        var cctTbody = Array.from(currentElement.getElementsByClassName("cct-tbody"))
        var cctTbodytTd = Array.from(currentElement.getElementsByClassName(" cct-hidden-td "))

        if (value == "Take from Column") {
            // Values
            cctTbodyColumn.forEach(element => {
                element.classList.remove("hidden");
            });
            cctTbody.forEach(element => {
                element.classList.add("hidden");
            });
            cctTbodytTd.forEach(element => {
                element.classList.add("hidden");
            });

        } else {
            if (value == "Static") {
                // Values
                cctTbodyColumn.forEach(element => {
                    element.classList.add("hidden");
                });
                cctTbody.forEach(element => {
                    element.classList.remove("hidden");
                });
                cctTbodytTd.forEach(element => {
                    element.classList.remove("hidden");
                });
            } else {
                // Values
                cctTbodyColumn.forEach(element => {
                    element.classList.add("hidden");
                });
                cctTbody.forEach(element => {
                    element.classList.add("hidden");
                });
                cctTbodytTd.forEach(element => {
                    element.classList.add("hidden");
                });
            }
        }
    }

    amountMode(event) {
        var value = event.target.value;
        var element = event.target.parentElement.parentElement;
        var selectTag = element.querySelector('.gl-amount-column'); // Use querySelector for selecting by class
        var cctSelection = element.querySelector('.gl-cc-type-selection')
        var opts = ["Take from Column", "Static"]

        this.emptyOption(selectTag)

        var amountFields = JSON.parse(this.amountFields())
        if (value === "Col Reference") {
            amountFields.forEach(field => {
                selectTag.tomselect.addOption({value: field, text: field});
            })
            // CCT SELECTION
            opts.forEach(field => {
                cctSelection.tomselect.addOption({value: field, text: field});
            })
        } else {
            // Amount Column
            this.emptyOption(selectTag)
            selectTag.tomselect.clear()
            selectTag.tomselect.clearOptions()
            // CCT SELECTION
            cctSelection.tomselect.clear()
            cctSelection.tomselect.clearOptions()
            cctSelection.tomselect.addOption({value: "Static", text: "Static"});
        }
    }


    emptyOption(selectTag) {
        let option = document.createElement('option');
        option.value = '';
        option.text = 'Select Gl Account';
        selectTag.appendChild(option);
    }

    reportData() {
        const dataDiv = document.getElementsByClassName('report-table-data-div')
        return dataDiv.length == 1 ? dataDiv[0] : []
    }

    cloneRow(event) {
        event.preventDefault();
        const parent = document.querySelector("#entry_config_lists");
        const row = this.rowTargets[0];
        if (!row) {
            console.error("Row not found");
            return;
        }

        const newRow = row.cloneNode(true);
        const length = parent.children.length;

        const selects = newRow.querySelectorAll('select');
        selects.forEach((select, index) => {
            const originalId = select.id;

            const newId = `entry_config_${length}_${originalId}`;
            select.setAttribute('id', newId);
            select.setAttribute('name', `entry_config[${length}][${originalId}]`);

            select.removeAttribute('data-tom-select');

            select.value = '';

            new TomSelect(select, {});

            select.tomselect.destroy();
            var tags = Array.from(select.parentElement.children)
            tags.forEach(tag => {
                if (tag.tagName == "SELECT") {

                } else {
                    tag.remove()
                }
            })
        });
        parent.append(newRow);
        newRow.classList.remove('hidden')
        const deleteButton = newRow.querySelector("#delete-button");
        if (deleteButton) {
            deleteButton.classList.remove("hidden");
        }
    }

    deleteRow() {
        event.preventDefault()
        event.target.closest('tr').remove()
    }

    numbering_series(event) {
        var auto = document.getElementsByClassName('numbering-series-auto')[0]
        var manual = document.getElementsByClassName('numbering-series-manual')[0]
        if (event.target.value == 'take_from_column') {
            auto.classList.add('hidden')
            manual.classList.remove('hidden')
        } else if (event.target.value == 'static') {
            auto.classList.remove('hidden')
            manual.classList.add('hidden')
        } else {
            auto.classList.add('hidden')
            manual.classList.add('hidden')
        }
    }

    amountFields() {
        return this.reportData().dataset.amountFields
    }

}